import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("polygon", {
				className: "icon-fill-primary",
				points: "35.9 11.6 33.4 11.6 33.4 5.3 22.5 2.6 11.6 5.3 11.6 11.5 9.1 11.5 9.1 3.4 22.5 0 35.9 3.4"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-primary",
				d: "M35.1 41.4l-1.4-2.1 1.4-1c2.6-1.8 4.1-4.7 4.1-7.8V14L22.5 9.8 5.8 14v16.5c0 3.1 1.5 6 4.1 7.8l1.4 1-1.4 2.1-1.4-1c-3.2-2.2-5.2-5.9-5.2-9.9V12l19.2-4.8L41.7 12v18.5c0 3.9-1.9 7.6-5.2 9.9l-1.4 1z"
			}),
			/* @__PURE__ */ _jsx("polygon", {
				className: "icon-fill-primary",
				points: "40.2 20.9 22.5 16.4 4.8 20.9 4.2 18.4 22.5 13.9 40.8 18.4"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-primary",
				d: "M24.2 42.8l-2.5-.4c1.2-6.9 5.1-19.3 18.3-23.9l.8 2.4c-12 4.2-15.5 15.5-16.6 21.9z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-primary",
				d: "M20.8 42.8c-1.1-6.4-4.7-17.7-16.7-22l.8-2.4c13.2 4.7 17.2 17 18.3 23.9l-2.4.5z"
			})
		] }),
		/* @__PURE__ */ _jsx("rect", {
			x: 21.2,
			y: 8.7,
			className: "icon-fill-primary",
			width: 2.5,
			height: 31.8
		}),
		/* @__PURE__ */ _jsxs("g", { children: [
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M3.2 45H0v-2.5h3.2c4.6 0 8.4-3.8 8.4-8.4h2.5c0 6-4.9 10.9-10.9 10.9z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M22.5 45c-6 0-10.9-4.9-10.9-10.9h2.5c0 4.6 3.8 8.4 8.4 8.4V45z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M22.5 45v-2.5c4.6 0 8.4-3.8 8.4-8.4h2.5c0 6-4.9 10.9-10.9 10.9z"
			}),
			/* @__PURE__ */ _jsx("path", {
				className: "icon-fill-secondary",
				d: "M45 45h-3.2c-6 0-10.9-4.9-10.9-10.9h2.5c0 4.6 3.8 8.4 8.4 8.4H45V45z"
			})
		] })
	]
});
export default SvgIcon;
